angular.module('acme.view.application.reports.results.controllers', [
  'ui.router',
  'acme.common.factory.gridDefinition',
  'acme.common.factory.gridState',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.permissions',
  'acme.common.service.reportingApi',
  'acme.common.service.userPreferences',
  'acme.view.application.reports.list.createModal.controllers'
]).controller('ReportsResultsController', [
  '$scope',
  '$state',
  '$filter',
  'ReportingApiService',
  'CalendarService',
  'HelpersService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'PermissionsService',
  'UserPreferencesService',
  function ($scope,
            $state,
            $filter,
            ReportingApiService,
            CalendarService,
            HelpersService,
            GridStateFactory,
            GridDefinitionFactory,
            PermissionsService,
            UserPreferencesService) {
    $scope.reportsResults = {
      model: [],
      searchQuery: null,
      viewId: '',
      resultsResultsGridName: $state.current.name + '.grid0',
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      isLoaded: false,

      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTimeAlt'),

      optionsOverride: {
        data: 'reportsResults.model',
        useAccessibleGrid: true,
        rowHeight: 42,
        appScopeProvider: {
          onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.reportsResults.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function (grid, columns, page) {
            $scope.reportsResults.onDataGridSortChange(grid, columns, page);
          },
          getDateRangeFormatted: function(data) {
            return $scope.reportsResults.getDateRangeFormatted(data);
          },
          isReportReady: function (data) {
            return $scope.reportsResults.validateAsyncReport(data);
          },
          viewItem: function (item) {
            if ($scope.reportsResults.validateAsyncReport(item)) {
              $scope.reportsResults.viewItem(item);
            }
          },
          getCsvUrl: function (item) {
            return $scope.reportsResults.getCsvUrl(item);
          },
          launchPrint: function (item) {
            if ($scope.reportsResults.validateAsyncReport(item)) {
              $scope.reportsResults.launchPrint(item);
            }
          },
          removeReport: function (item) {
            $scope.reportsResults.remove(item);
          }
        },
        columnDefs: [{
          field: 'id',
          displayName: 'ID',
          enableSorting: false,
          visible: false
        }, {
          field: 'reportName',
          displayName: 'Name',
          visible: true
        }, {
          field: 'status',
          enableSorting: false,
          displayName: 'Status',
          visible: true
        }, {
          field: 'dateRangeField',
          enableSorting: false,
          displayName: 'Date Field',
          visible: true
        }, {
          field: 'range',
          cellTemplate: '<div data-ng-class="col.colIndex()">{{ grid.appScope ? grid.appScope.getDateRangeFormatted(row.entity) : reportsResults.optionsOverride.appScopeProvider.getDateRangeFormatted(row.entity) }}</div>',
          displayName: 'Range',
          width: 160,
          enableSorting: false,
          visible: true
        }, {
          field: 'createdBy',
          displayName: 'Requested By',
          enableSorting: false,
          visible: true
        }, {
          field: 'csvUrl',
          displayName: 'Download csv',
          visible: true,
          enableSorting: false,
          cellTemplate: '<div class="ui-grid-cell-contents">' +
                        '<a data-ng-if="grid.appScope ? grid.appScope.isReportReady(row.entity) : reportsResults.optionsOverride.appScopeProvider.isReportReady(row.entity)"' +
                          'target="_blank" role="link" data-ng-href="{{ grid.appScope ? grid.appScope.getCsvUrl(row.entity) : reportsResults.optionsOverride.appScopeProvider.getCsvUrl(row.entity) }}">' +
                        'Download CSV' +
                        '<span class="sr-only">opens new window</span>' +
                        '</a></div>'
        }, {
          field: 'print',
          displayName: 'print',
          visible: true,
          enableSorting: false,
          onCellNavClick: function (rowData) {
            if ($scope.reportsResults.validateAsyncReport(rowData.entity)) {
              $scope.reportsResults.launchPrint(rowData.entity);
            }
          },
          cellTemplate: '<div data-ng-if="grid.appScope ? grid.appScope.isReportReady(row.entity) : reportsResults.optionsOverride.appScopeProvider.isReportReady(row.entity)"' +
                        'data-ng-click="grid.appScope.launchPrint(row.entity)" class="ui-grid-cell-contents">' +
                        '<a role="button">Print<span class="sr-only">opens new window</span></a></div>'
        }]
      },

      validateAsyncReport: function (asyncReport) {
        return asyncReport.status.toUpperCase() === 'COMPLETED';
      },

      getDateRangeFormatted: function (param) {
        var self = $scope.reportsResults;
            startDate = param.startDate || param.data.startDate || '',
            endDate = param.endDate || param.data.endDate || '';

        return [startDate, endDate]
            .map(function (date) {
              var r,
                  splitDate;

                if (/\d{1,2}T\d{2}/.test(date)) {
                  r = $filter('date')(CalendarService.parseDate(date), self.dateTimeFormat);
                }else {
                  splitDate = date.split('-');
                  r = $filter('date')(new Date(splitDate[0], parseInt(splitDate[1], 10) - 1, splitDate[2]), self.dateTimeFormat);
                }

                return r;
            })
            .join(' - ');
      },

      getCsvUrl: function (item) {
        var id = item.id,
          csvUrl = ReportingApiService.asyncReports.csvUrl;

        return [csvUrl, id].join('/');
      },

      init: function () {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Reports'
        });

        if (PermissionsService.check('REPORTS_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'view',
            displayName: 'View',
            width: 80,
            enableHiding: false,
            enableSorting: false,
            onCellNavClick: function (rowData) {
              if ($scope.reportsResults.validateAsyncReport(rowData.entity)) {
                $scope.reportsResults.viewItem(rowData.entity);
              }
            },
            cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()">' +
                          '<a data-ng-if="grid.appScope ? grid.appScope.isReportReady(row.entity) : reportsResults.optionsOverride.appScopeProvider.isReportReady(row.entity)" data-ng-click="grid.appScope.viewItem(row.entity)" role="button">View</a>' +
                          '<span data-ng-if="!(grid.appScope ? grid.appScope.isReportReady(row.entity) : reportsResults.optionsOverride.appScopeProvider.isReportReady(row.entity))">View</span>' +
                          '</div>'
          });
        }

        if (PermissionsService.check('REPORTS_DELETE')) {
          var deleteColumn = {
            field: 'remove',
            displayName: 'Remove',
            enableHiding: false,
            enableSorting: false,
            onCellNavClick: function (rowData) {
              $scope.reportsResults.remove(rowData.entity);
            },
            cellTemplate: '<div data-ng-click="grid.appScope.removeReport(row.entity)" class="ui-grid-cell-contents"><a role="button">Remove</a></div>'
          };

          this.optionsOverride.columnDefs = [].concat(this.optionsOverride.columnDefs, deleteColumn);
        }

        this.viewId = $state.current.name;
        this.searchQuery = $state.params.search;
        this.gridDefinition.init(this.resultsResultsGridName, this.optionsOverride, this.viewId, $state.current
          .data
          .enablePreferences);

        this.initDateFormats();

        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
      },

      initData: function () {
        var self = $scope.reportsResults,
          props = self.gridDefinition.getGridState();

        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getAsyncReports();
      },

      initDateFormats: function() {
        var self = $scope.reportsResults;

        self.optionsOverride.columnDefs.splice(1, 0, {
          field: 'updatedOn',
          displayName: 'Date Completed',
          sort: {
            direction: 'desc'
          },
          visible: true,
          cellFilter: 'date : "' + self.dateTimeFormat + '"',
        });
      },

      launchPrint: function (asyncReport) {
        var _asyncReport = asyncReport || {},
          wHeight = screen.availHeight - 20,
          wWidth = screen.availWidth - 20;

        // Open print window
        HelpersService.setCookie('report', {
          endDate: _asyncReport.endDate,
          startDate: _asyncReport.startDate,
          dateRangeField: _asyncReport.dateRangeField,
          queryExpression: _asyncReport.queryExpression,
          name: _asyncReport.reportName,
          description: _asyncReport.description,
          id: _asyncReport.id,
          async: true
        });

        window.open('/app/reports/print', _asyncReport.reportName, 'height=' + wHeight + ',width=' +
          wWidth + ',left=10,scrollbars=yes,resizable=yes');
        return;
      },

      getAsyncReports: function () {
        var startTimeQuery =
            this.startTimeQuery &&
            moment(this.startTimeQuery).startOf('day').format(),
          endTimeQuery =
            this.endTimeQuery &&
            moment(this.endTimeQuery).endOf('day').format();

        this.isLoaded = false;
        this.gridState.setPropertyValue('search', this.searchQuery);
        this.gridState.setPropertyValue('startTime', startTimeQuery);
        this.gridState.setPropertyValue('endTime', endTimeQuery);
        ReportingApiService.asyncReports
          .list(this.gridState.getGridState())
          .then(this.success.getAsyncReports, this.error.getAsyncReports);
      },

      search: function () {
        var self = $scope.reportsResults;

        self.gridState.setPropertyValue('search', self.searchQuery);
        $scope.$broadcast('DataGrid::Search', {
          name: self.gridDefinition.options.gridName
        });
      },

      success: {
        getAsyncReports: function (response) {
          var self = $scope.reportsResults;

          self.model = response.data.payload.list;
          self.isLoaded = true;
          self.gridDefinition.isLoaded = true;
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.model.length,
            totalItems: response.data.payload.pagination.count
          });
        }
      },
      error: {
        getAsyncReports: function () {
          var self = $scope.reportsResults;

          self.isLoaded = true;
        }
      },

      remove: function (item) {
        var id = item.id,
          context = $scope.reportsResults,
          callback = null;

        callback = context.getAsyncReports.bind(context);
        ReportingApiService.asyncReports.remove(id).then(callback);
      },

      viewItem: function (item) {
        $state.go('application.reports.result', {
          definitionId: item.reportUuid,
          resultId: item.id,
          reportJson: ReportingApiService.asyncReports.getJson(item.id),
          reportStatus: item
        });
      },

      onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
        var self = $scope.reportsResults;

        self.gridState.updateGridState(newPage, pageSize, sortField, sortDirection);
        self.getAsyncReports();
      },

      onDataGridSortChange: function (grid, columns, page) {
        var self = $scope.reportsResults,
          data = columns[0];

        self.gridState.updateGridState(page, null, data.field, data.sort.direction);
        self.getAsyncReports();
      }
    };

    $scope.reportsResults.init();
  }
]);